<header class="ib-modals__header ib-modals__header--inside u-pb-xmedium u-pb-xs">
    <h2 class="ib-heading ib-heading--type-18 ib-heading--full">
        <span class="ib-heading__text">{{model.title|translate}}</span>
    </h2>
</header>
<section class="ib-modals__body">
    <div class="ib-layout__line-spacing ib-layout__line-spacing--medium">
        <p class="ib-text ib-text--block">{{model.body|translate}}</p>
    </div>
</section>
<div *ngIf="isLoading" class="ib-ui-loading ib-ui-loading--type-1">
    <div class="ib-ui-loading__container">
        <div class="ib-ui-loading__icon">
            <div class="circle"></div>
            <div class="circle"></div>
        </div>
    </div>
</div>
<footer class="ib-modals__footer u-text-right">
    <button class="ib-button ib-button--w-medium" type="button" (click)="continue()">{{model.accept|translate}}</button>
</footer>
